import HttpClient from "@/api/HttpClient"
import END_POINT from '@/api/EndPoints'

let securityAuth = wpvue_script_data_params.data.site_data.enable_api_auth_secret
let securityAuthCode = wpvue_script_data_params.data.site_data.api_auth_secret
let getHomePage = ""
let getNavLinks = ""
let getFooter = ""
let getBody = ""
let getArchive = ""
let getHomepagewithscroll = ""
let getSearchResult = ""
let userArticleVote = ""
let getPreview = ""
let get404Body = ""

if (securityAuth) {
    getHomePage = (country, state, userId, preview) => {
        if (preview) {
            return HttpClient.get(`${END_POINT.HomePage}${country}&state=${state}&user_id=${userId}&preview=true&secret_key=${securityAuthCode}`)
        } else {
            return HttpClient.get(`${END_POINT.HomePage}${country}&state=${state}&user_id=${userId}&secret_key=${securityAuthCode}`)
        }
    }
    getHomepagewithscroll = (country, state, userId, preview) => {
        if (preview) {
            return HttpClient.get(`${END_POINT.HomePage}${country}&state=${state}&user_id=${userId}&preview=true&secret_key=${securityAuthCode}&scroll=true`)
        } else {
            return HttpClient.get(`${END_POINT.HomePage}${country}&state=${state}&user_id=${userId}&secret_key=${securityAuthCode}&scroll=true`)
        }
    }
    getNavLinks = (country, state) => HttpClient.get(`${END_POINT.NavLinks}${country}&state=${state}&secret_key=${securityAuthCode}`)

    getFooter = (country, state) => HttpClient.get(`${END_POINT.Footer}/?country=${country}&state=${state}&secret_key=${securityAuthCode}`)

    getBody = (country, state, slug, userId, castoplist = {}) => {
        let castoplistValue = ''
        for (const [key, value] of Object.entries(castoplist)) {
            castoplistValue = castoplistValue + '&' + key + '=' + value
        }
        return HttpClient.get(`${END_POINT.Body}${slug}&country=${country}&state=${state}&user_id=${userId}${castoplistValue}&secret_key=${securityAuthCode}`)
    }

    getArchive = (country, state, archive, page, sortOrder, userId, term) => {
        return HttpClient.get(`${END_POINT.Archive}?archive=${archive}&country=${country}&state=${state}&orderby=title&order=${sortOrder}&page=${page}&user_id=${userId}&term=${term}&secret_key=${securityAuthCode}`)
    }

    getSearchResult = (country, state, text, page, sortOrder, userId, orderBy) => HttpClient.post(`${END_POINT.Search}${text}&country=${country}&state=${state}&orderby=${orderBy || 'relevance'}&order=${sortOrder}&page=${page}&user_id=${userId}&secret_key=${securityAuthCode}`)

    userArticleVote = (country, state, slug, userId, vote) => HttpClient.get(`${END_POINT.ArticleVote}${slug}&country=${country}&state=${state}&user_id=${userId}&vote=${vote}&secret_key=${securityAuthCode}`)

    getPreview = (country, state, slug, userId) => HttpClient.get(`${END_POINT.Body}${slug}&country=${country}&state=${state}&user_id=${userId}&preview=true&secret_key=${securityAuthCode}`)

    //404 edit

    get404Body = (country, state, slug, userId, castoplist = {}) => {
            let body404Data = {
                'resource_id': slug,
                'country': country,
                'state': state,
                'user_id': userId,
                'secret_key': securityAuthCode
                }
        
        
            // return HttpClient.post(`${END_POINT.Body}${slug}`, body404Data)

            return HttpClient.get(
              `${END_POINT.Body}${slug}&` +
                Object.keys(body404Data)
                  .filter((i) => i !== "resource_id")
                  .map((key) => `${key}=${body404Data[key]}`)
                  .join("&")
            );
        }
        //get404Body = (country, state, slug, userId) => HttpClient.post(`${END_POINT.Body}${slug}&country=${country}&state=${state}&user_id=${userId}&secret_key=${securityAuthCode}`)

} else {
    getHomePage = (country, state, userId, preview) => {
        if (preview) {
            return HttpClient.get(`${END_POINT.HomePage}${country}&state=${state}&user_id=${userId}&preview=true`)
        } else {
            return HttpClient.get(`${END_POINT.HomePage}${country}&state=${state}&user_id=${userId}`)
        }
    }
    getHomepagewithscroll = (country, state, userId, preview) => {
        if (preview) {
            return HttpClient.get(`${END_POINT.HomePage}${country}&state=${state}&user_id=${userId}&preview=true&scroll=true`)
        } else {
            return HttpClient.get(`${END_POINT.HomePage}${country}&state=${state}&user_id=${userId}&scroll=true`)
        }
    }
    getNavLinks = (country, state) => HttpClient.get(`${END_POINT.NavLinks}${country}&state=${state}`)

    getFooter = (country, state) => HttpClient.get(`${END_POINT.Footer}/?country=${country}&state=${state}`)

    getBody = (country, state, slug, userId, castoplist = {}) => {
        let castoplistValue = ''
        for (const [key, value] of Object.entries(castoplist)) {
            castoplistValue = castoplistValue + '&' + key + '=' + value
        }
        return HttpClient.get(`${END_POINT.Body}${slug}&country=${country}&state=${state}&user_id=${userId}${castoplistValue}`)

        // let bodyData = {
        //     'resource_id': slug,
        //     'country': country,
        //     'state': state,
        //     'user_id': userId,
        //     ...castoplist
        // }
        // return HttpClient.post(`${END_POINT.Body}${slug}`, bodyData)
    }
    
    getArchive = (country, state, archive, page, sortOrder, userId, term) => {
        return HttpClient.get(`${END_POINT.Archive}?archive=${archive}&country=${country}&state=${state}&orderby=title&order=${sortOrder}&page=${page}&user_id=${userId}&term=${term}`)
    }

    //Search api need to be done as post method
    getSearchResult = (country, state, text, page, sortOrder, userId, orderBy) => HttpClient.post(`${END_POINT.Search}${text}&country=${country}&state=${state}&orderby=${orderBy || 'relevance'}&order=${sortOrder}&page=${page}&user_id=${userId}`)

    userArticleVote = (country, state, slug, userId, vote) => HttpClient.get(`${END_POINT.ArticleVote}${slug}&country=${country}&state=${state}&user_id=${userId}&vote=${vote}`)

    getPreview = (country, state, slug, userId) => HttpClient.get(`${END_POINT.Body}${slug}&country=${country}&state=${state}&user_id=${userId}&preview=true`)

    //404 edit

    get404Body = (country, state, slug, userId, castoplist = {}) => {
        let body404Data = {
            'resource_id': slug,
            'country': country,
            'state': state,
            'user_id': userId
            }
    
    
        // return HttpClient.post(`${END_POINT.Body}${slug}`, body404Data)

        return HttpClient.get(
          `${END_POINT.Body}${slug}&` +
            Object.keys(body404Data)
              .filter((i) => i !== "resource_id")
              .map((key) => `${key}=${body404Data[key]}`)
              .join("&")
        );
    }

    //get404Body = (country, state, slug, userId) => HttpClient.get(`${END_POINT.Body}${slug}&country=${country}&state=${state}&user_id=${userId}&preview=1`)
}

export const HttpService = {
    getHomePage,
    getNavLinks,
    getFooter,
    getBody,
    getArchive,
    getHomepagewithscroll,
    getSearchResult,
    userArticleVote,
    getPreview,
    get404Body
}


// WEBPACK FOOTER //
// ./src/api/Pages.api.js